import React, { useEffect, useState } from "react";
import { Card, Container, Button } from "react-bootstrap";
import CommonReactTable from "../CommonUtils/CommonReactTable";
import { CommonAxiosGet } from "../CommonUtils/CommonAxios";
import { config } from "../CommonUtils/CommonURLS";
import CommonCardHeader from "../CommonUtils/CommonCardHeader";

export default function CollegesAdmissionDetailsReport() {
  const [collegeAdmissionData, setCollegeAdmissionData] = useState([]);
  const [collegeAdmissionTable, setCollegeAdmissionTable] = useState(false);
  const [collegeSubmittedData, setCollegeSubmittedData] = useState([]);
  const [collegeSubmittedTable, setCollegeSubmittedTable] = useState(false);
  const [selectedCollege, setSelectedCollege] = useState(null);

  //   ******** drill 1*****
  function getCollegeAdmissionData() {
    CommonAxiosGet(config.url.STU_URL + "getcoursesbycollegeintakesubmitdept").then((res) => {
      if (res?.data?.status === true) {
        setCollegeAdmissionData(res?.data?.scode === "01" ? res.data?.college_courses_intake : []);
        setCollegeAdmissionTable(true);
        setCollegeSubmittedTable(false);
      } else {
        setCollegeAdmissionData([]);
        setCollegeAdmissionTable(true);
        setCollegeSubmittedTable(false);
      }
    });
  }

  //   ******** drill 2*****
  const getCollegeSubmittedData = (collCode, collegeName) => {
    const admissionUrl = `${config.url.STU_URL}getcoursesbycollegeintakesubmit/${collCode}`;
    CommonAxiosGet(admissionUrl).then((admissionRes) => {
      if (admissionRes?.data?.status === true) {
        const data = admissionRes?.data?.college_courses_intake || [];
        setCollegeSubmittedData(data);
        setCollegeSubmittedTable(true);
        setCollegeAdmissionTable(false);
        setSelectedCollege({ code: collCode, name: collegeName });
      } else {
        setCollegeSubmittedData([]);
        setCollegeSubmittedTable(true);
        setCollegeAdmissionTable(false);
        setSelectedCollege({ code: collCode, name: collegeName });
      }
    });
  };

  //   ******** back button*****
  const handleBack = () => {
    setCollegeAdmissionTable(true);
    setCollegeSubmittedTable(false);
    setSelectedCollege(null);
    setCollegeSubmittedData([]);
  };

  useEffect(() => {
    getCollegeAdmissionData();
  }, []);

  const centeredMeta = { style: { textAlign: "center" } };

  const createYearVacancyColumns = (yearId, yearLabel, accessorPrefix) => ({
    id: yearId,
    header: yearLabel,
    columns: [
      {
        id: `${accessorPrefix}_cq`,
        header: "CQ",
        accessorKey: `${accessorPrefix}_cq`,
        meta: centeredMeta,
      },
      {
        id: `${accessorPrefix}_mq`,
        header: "MQ",
        accessorKey: `${accessorPrefix}_mq`,
        meta: centeredMeta,
      },
    ],
  });

  // Columns for main table (All Colleges)
  const collegeColumns = [
    {
      id: "college_slNo",
      header: "S.No",
      cell: ({ row }) => row.index + 1,
    },
    {
      id: "coll_code",
      header: "College Code",
      accessorKey: "coll_code",
      meta: centeredMeta,
    },
    {
      id: "coll_name",
      header: "College Name",
      accessorKey: "coll_name",
      meta: centeredMeta,
    },
    {
      id: "ub_name",
      header: "University Name",
      accessorKey: "ub_name",
      meta: { style: { textAlign: "left" } },
    },
    {
      id: "count",
      header: "Total Courses",
      accessorKey: "count",
      meta: { style: { textAlign: "right" } },
      cell: ({ row }) => (
        <button
          className="btn btn-link p-0 text-primary text-start"
          style={{ textDecoration: "underline", cursor: "pointer" }}
          onClick={() => getCollegeSubmittedData(row.original.coll_code, row.original.coll_name)}
        >
          {row.original.count}
        </button>
      ),
    },
  ];

  // Columns for drill-down table (Course details)
  const courseColumns = [
    {
      id: "course_slNo",
      header: "S.No",
      cell: ({ row }) => row.index + 1,
    },
    {
      id: "course_cat_name",
      header: "Course Category",
      accessorKey: "course_cat_name",
      meta: { style: { textAlign: "left" } },
    },
    {
      id: "course_name",
      header: "Course Name",
      accessorKey: "course_name",
      cell: ({ row }) => row.original.course_name?.trim(),
      meta: { style: { textAlign: "left" } },
    },
    {
      id: "sanction_intake",
      header: "Sanction Intake",
      accessorKey: "sanction_intake",
      meta: centeredMeta,
    },
    {
      id: "ac_year",
      header: "Academic Year",
      accessorKey: "ac_year",
      meta: centeredMeta,
    },
    {
      id: "UnFilledVacancies",
      header: "Un Filled vacancies",
      columns: [
        createYearVacancyColumns("firstYear", "I Year", "first_year"),
        createYearVacancyColumns("secondYear", "II Year", "second_year"),
        createYearVacancyColumns("thirdYear", "III Year", "third_year"),
        createYearVacancyColumns("fourthYear", "IV Year", "fourth_year"),
      ],
    },
  ];

  return (
    <div>
      <Container fluid className="py-4">
        <section className="workflow-section-surface">
          <CommonCardHeader
            title={collegeSubmittedTable ? `Admission Details - ${selectedCollege?.name || "College"}` : "Colleges Admission Details Report"}
            subtitle={collegeSubmittedTable ? `College Code: ${selectedCollege?.code} | Course wise vacancy details` : "View all admission data - Click on Total Courses to view details"}
          />
          <div className="workflow-section-body">
            {collegeAdmissionTable && (
              <>
                {collegeAdmissionData?.length > 0 ? (
                  <CommonReactTable
                    data={collegeAdmissionData}
                    columns={collegeColumns}
                    filename="CollegesAdmissionDetailsReport"
                    headerName="Colleges Admission Details Report"
                    showFooter={false}
                    showPagination={false}
                    showExcel={true}
                    showPrint={true}
                    excelFileName="Colleges_Admission_Report"
                  />
                ) : (
                  <div className="text-center text-danger fw-bold fs-6">**** No Data Found ****</div>
                )}
              </>
            )}

            {collegeSubmittedTable && (
              <>
                <div className="d-flex justify-content-end mb-3">
                  <Button variant="secondary" size="sm" onClick={handleBack}>
                    ← Back to Colleges
                  </Button>
                </div>
                {collegeSubmittedData?.length > 0 ? (
                  <CommonReactTable
                    data={collegeSubmittedData}
                    columns={courseColumns}
                    filename={`AdmissionDetails_${selectedCollege?.code}`}
                    headerName={`Admission Details - ${selectedCollege?.name}`}
                    showFooter={false}
                    showPagination={false}
                    showExcel={true}
                    showPrint={true}
                    excelFileName={`Admission_Details_${selectedCollege?.code}`}
                  />
                ) : (
                  <div className="text-center text-danger fw-bold fs-6">**** No Course Data Found ****</div>
                )}
              </>
            )}
          </div>
        </section>
      </Container>
    </div>
  );
}
